import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UrlSanitizerPipe } from './url-sanitizer.pipe';

@NgModule({
  declarations: [UrlSanitizerPipe],
  exports: [UrlSanitizerPipe],
  imports: [
    CommonModule
  ]
})
export class UrlSanitizerModule { }
